import {
  createBrowserRouter,
  Outlet,
} from "react-router-dom";
import ErrorPage from "../../error-page";
import NotFound from "./NotFound";

const routerSatisfaction = createBrowserRouter([
  {
    path: "/",
    element: <><Outlet/></>,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: (
          <div className="tw-bg-white tw-p-4 tw-rounded-md tw-shadow-md">
            <h1>Welcome</h1>
          </div>
        ),
      },
      {
        path: "contacts/:contactId",
        element: <h1>Contact!</h1>,
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  }

]);

export default routerSatisfaction;